import { render, staticRenderFns } from "./PH2Z.vue?vue&type=template&id=47e32c58&scoped=true"
import script from "./PH2Z.vue?vue&type=script&lang=js"
export * from "./PH2Z.vue?vue&type=script&lang=js"
import style0 from "./PH2Z.vue?vue&type=style&index=0&id=47e32c58&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e32c58",
  null
  
)

export default component.exports